










































import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { temiCaldiLink } from '~/helpers/trackings/24orepro/pages';

export default defineComponent({
    props: {
        classes: {
            type: Object,
            default: () => { return {} }
        },
        breadCrumb: {
            type: Object as PropType<{ url: string, label: string }>
        },
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String
        },
        cta: {
            type: Object as PropType<{ href: string, label: string, icon?: string }>
        },
        imageSrc: {
            type: String
        }
    },
    data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg')
        }
    },
    setup() {
        const trackTemiCaldiLink = () => temiCaldiLink();
        return {
            trackTemiCaldiLink
        }
    },
})
